
        <header *ngIf="loadTabs"></header>
        <router-outlet *ngIf="loadTabs"></router-outlet>
        <div class="loading1" *ngIf="showLoading">
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center">
                <img src="./assets/img/load.gif" alt="loading" width="80px">
            </div>
            <div class="loader-div">
                <div class="loader-gif"></div>
            </div>
        </div>
    


// WEBPACK FOOTER //
// ./src/app/app.component.ts.AppComponent.html